import { render, staticRenderFns } from "./editMoney.vue?vue&type=template&id=54b2a3ce&scoped=true&"
import script from "./editMoney.vue?vue&type=script&lang=js&"
export * from "./editMoney.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b2a3ce",
  null
  
)

export default component.exports